export const onDialogConfirmConfirmProp = () => ({
  widget: 'models',
  type: 'onDialogConfirmConfirmProp',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogConfirmConfirmProp.js